// extracted by mini-css-extract-plugin
module.exports = {"counter__numbers":"_kl","counter__number":"_km"};